import Component from '../../common/Component';
import SlideShow from '../../common/components/SlideShow';
import ItemList from '../../common/utils/ItemList';
import app from '../app';

/**
 * The `HeaderPrimary` component displays primary header controls. On the
 * default skin, these are shown just to the right of the forum title.
 */
export default class AdsTopComponent extends Component {

  oninit(vnode) {
    super.oninit(vnode);
    this.hidden = false;
  }

  view() {

    return <div class='ads-top-container  web'>
      {this.getWebItem()}
    </div>;
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    const items = new ItemList();

    return items;
  }

  getWebItem() {
    return <div class="adsTop-container">
      <div class="adTopItem adsTop-left">
        <SlideShow slideWidth={290} slideName="slide-adsTop-left" containerId="container-adsTop-left" imgList={this.getAdsBanner('forum_ad_1')} autoSlideTime={7}>
        </SlideShow>
      </div>
      <div class="adTopItem adsTop-row1-Col2">
        <SlideShow slideWidth={580} slideName="slide-adsTop-row1-Col2" containerId="container-adsTop-row1-Col2" imgList={this.getAdsBanner('forum_ad_2')} autoSlideTime={6}>
        </SlideShow>
      </div>
      <div class="adTopItem adsTop-row1-Col3">
        <SlideShow slideWidth={312} slideName="slide-adsTop-row1-Col3" containerId="container-adsTop-row1-Col3" imgList={this.getAdsBanner('forum_ad_5')} autoSlideTime={6}>
        </SlideShow>
      </div>
      <div class="adTopItem adsTop-row2-Col2">
        <SlideShow slideWidth={580} slideName="slide-adsTop-row2-Col2" containerId="container-adsTop-row2-Col2" imgList={this.getAdsBanner('forum_ad_3')} >
        </SlideShow>
      </div>
      <div class="adTopItem adsTop-row2-Col3">
        <SlideShow slideWidth={312} slideName="slide-adsTop-row2-Col3" containerId="container-adsTop-row2-Col3" imgList={this.getAdsBanner('forum_ad_6')} >
        </SlideShow>
      </div>
      <div class="adTopItem adsTop-row3-Col2">
        <SlideShow slideWidth={580} slideName="slide-adsTop-row3-Col2" containerId="container-adsTop-row3-Col2" imgList={this.getAdsBanner('forum_ad_4')} autoSlideTime={4}>
        </SlideShow>
      </div>
      <div class="adTopItem adsTop-row3-Col3">
        <SlideShow slideWidth={312} slideName="slide-adsTop-row3-Col3" containerId="container-adsTop-row3-Col3" imgList={this.getAdsBanner('forum_ad_7')} autoSlideTime={4}>
        </SlideShow>
      </div>
    </div>
      ;
  }

  getAdsBanner(type) {
    let data = app.adsbannerData;
    if (data) {
      let list = data.list.banner[type];
      if (list) {
        if (list.length == 1) {
          list.push(list[0]);
        }
        return list;
      }
    }
    return null;
  }
}
